// extracted by css-extract-rspack-plugin
export default {"viewAllWrapper":"_3b75fc6","viewAllCta":"_67d7dd83"};